import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Layout } from 'antd/lib';

import CrearCertificacion from './certificacion/CrearCertificacion';
import CrearDeclaracionJurada from './DeclaracionJurada/CrearDeclaracionJurada';
import CrearAutorizacionOtros from './Autorizaciones/CrearAutorizacionOtros';
import CrearAutorizacionMenor from './Autorizaciones/CrearAutorizacionMenor';
import CrearAutorizacionTrabajoMenor from './Autorizaciones/CrearAutorizacionTrabajoMenor';
import CrearRegistroEntradaSalida from './RegistroEntradaSalida/CrearRegistroEntradaSalida';
import CrearAcreditacion from './Acreditaciones/CrearAcreditacion';
import ActualizarDatosPersona from './ActualizarDatosPersona/ActualizarDatosPersona';
import CrearArregloExtrajudicial from './ArregloExtrajudicial/CrearArregloExtrajudicial';
import ListarAcuerdosExtrajudiciales from './ArregloExtrajudicial/ListarAcuerdosExtrajudiciales';
import VerAcuerdoExtrajudicial from './ArregloExtrajudicial/VerAcuerdoExtrajudicial';
import AgregarDocumento from './ArregloExtrajudicial/AgregarDocumento';
import BuscarAntecedentes from './Antecedentes/BuscarAntecedentes';

import SumarPersona from './Autorizaciones/SumarPersona';

// import VenderSello from '../admGeneral/ventaSellos/VenderSellos';
import CrearAtencion from './Atencion/CrearAtencion';
import CrearInformacionSumaria from './InformacionSumaria/CrearInformacionSumaria';

import CrearOficio from './Oficios/CrearOficio';
class Routes extends React.PureComponent {
  render() {
    const { Content } = Layout;

    return (
      <Layout
        style={{
          padding: '0 24px 24px',
        }}
      >
        <Content
          style={{
            padding: '0 24px 24px 24px',
            margin: 0,
          }}
        >
          <Switch>
            {/* <Route
              exact
              path={`${this.props.match.url}/sellos/vender`}
              component={VenderSello}
              {...this.props}
            /> */}

            <Route
              exact
              path={`${this.props.match.url}/certificacion/crear`}
              component={CrearCertificacion}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/declaracion/crear`}
              component={CrearDeclaracionJurada}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/acreditacion/crear`}
              component={CrearAcreditacion}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/autorizacion/otras/crear`}
              component={CrearAutorizacionOtros}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/autorizacion/menor/crear`}
              component={CrearAutorizacionMenor}
              {...this.props}
            />
            <Route
              exact
              path={`${this.props.match.url}/autorizacion/trabajomenor/crear`}
              component={CrearAutorizacionTrabajoMenor}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/atencion/crear`}
              component={CrearAtencion}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/personas/actualizar`}
              component={ActualizarDatosPersona}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/personas/antecedentes`}
              component={BuscarAntecedentes}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/informacionSumaria/crear`}
              component={CrearInformacionSumaria}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/autorizacion/menor/agregarPersona/`}
              component={SumarPersona}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/oficios/nuevo/`}
              component={CrearOficio}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/registrosEntradasSalidas/crear`}
              component={CrearRegistroEntradaSalida}
              {...this.props}
            />

            <Route
              exact
              path={`${this.props.match.url}/acuerdosExtrajudiciales/crear`}
              component={CrearArregloExtrajudicial}
              {...this.props}
            />
            <Route
              exact
              path={`${this.props.match.url}/acuerdosExtrajudiciales/listar`}
              component={ListarAcuerdosExtrajudiciales}
              {...this.props}
            />
            <Route
              exact
              path={`${this.props.match.url}/acuerdosExtrajudiciales/:id/ver`}
              component={VerAcuerdoExtrajudicial}
              {...this.props}
            />
            <Route
              exact
              path={`${this.props.match.url}/acuerdosExtrajudiciales/:id/agregarDocumento`}
              component={AgregarDocumento}
              {...this.props}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

Routes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Routes);
